import { RPC_EVENT_TYPE } from '../constants.js';
class WindowTransport {
    #window;
    #target;
    #allowedOrigins;
    constructor({ window, target, allowedOrigins }) {
        this.#window = window;
        this.#target = target;
        this.#allowedOrigins = new Set(allowedOrigins);
    }
    #isValidEvent(event) {
        const input = JSON.parse(event.data?.input || '{}');
        return (this.#allowedOrigins.has(event.origin) &&
            event.data?.type === RPC_EVENT_TYPE &&
            !input.method);
    }
    write(data) {
        const event = { type: RPC_EVENT_TYPE, input: data };
        this.#window.postMessage(event, this.#target);
    }
    on(eventName, listener) {
        window.addEventListener('message', (event) => {
            if (this.#isValidEvent(event)) {
                listener(event.data.input);
            }
        });
    }
    close() {
        this.#window.close();
    }
    removeListener() { }
}
export default WindowTransport;
